@use '@/scss/underscore' as _;

.icon {
  flex-shrink: 0;
}

.pagination {
  margin-top: _.unit(4);
}

.apiResourceName {
  width: 360px;
}
